module.exports = __webpack_public_path__ + "img/batchAddCollectors.85593cc9.png";